import { useMemo } from 'react'
import {
  getTableTotalsData,
  getWeatherCondition,
  getWeatherMessage,
} from '../utils/'
import { TIME_SLOTS } from '../../../options'

export const useStepResultsStats = data => {
  return useMemo(() => {
    const {
      uniqMissions,
      totalMissions,
      morningMissions,
      lunchMissions,
      afternoonMissions,
      weatherConditionsHashMap,
      badWeatherInADay,
    } = data.reduce(
      (acc, item) => {
        item.missions.forEach(mission => {
          acc.uniqMissions += 1
          acc.totalMissions += mission.basPerMission
          if (mission.timeSlot === TIME_SLOTS.MORNING) {
            acc.morningMissions += mission.basPerMission
          } else if (mission.timeSlot === TIME_SLOTS.LUNCH) {
            acc.lunchMissions += mission.basPerMission
          } else if (mission.timeSlot === TIME_SLOTS.AFTERNOON) {
            acc.afternoonMissions += mission.basPerMission
          }

          const weatherCondition = getWeatherCondition({
            weather: mission.weather,
            time: mission.time,
          })

          const warningWeatherMessage = getWeatherMessage({
            condition: weatherCondition,
            isSheltered: mission.isSheltered,
          })

          if (!acc.weatherConditionsHashMap[item.id]) {
            acc.weatherConditionsHashMap[item.id] = {}
          }

          acc.weatherConditionsHashMap[item.id][mission.locationId] = {
            weatherCondition,
            warningWeatherMessage,
          }

          if (warningWeatherMessage) {
            acc.badWeatherInADay[item.id] = true
          }
        })

        return acc
      },
      {
        uniqMissions: 0,
        totalMissions: 0,
        morningMissions: 0,
        lunchMissions: 0,
        afternoonMissions: 0,
        weatherConditionsHashMap: {},
        badWeatherInADay: {},
      },
    )
    const {
      morningMissionsPercentage,
      lunchMissionsPercentage,
      afternoonMissionsPercentage,
    } = {
      morningMissionsPercentage: totalMissions
        ? `${((morningMissions / totalMissions) * 100).toFixed(1)}%`
        : 0,
      lunchMissionsPercentage: totalMissions
        ? `${((lunchMissions / totalMissions) * 100).toFixed(1)}%`
        : 0,
      afternoonMissionsPercentage: totalMissions
        ? `${((afternoonMissions / totalMissions) * 100).toFixed(1)}%`
        : 0,
    }

    const tableFooterData = getTableTotalsData({
      morningMissions,
      lunchMissions,
      afternoonMissions,
      morningMissionsPercentage,
      lunchMissionsPercentage,
      afternoonMissionsPercentage,
    })

    return {
      tableFooterData,
      uniqMissions,
      totalMissions,
      weatherConditionsHashMap,
      badWeatherInADay,
    }
  }, [data])
}
